import React, {FC, PropsWithChildren, useMemo, useState} from 'react';

import {GrammarlyContext} from './grammarlyContext';

/*
 * Constants.
 */

const defaultRightSideWidth = 51;

/*
 * Component.
 */

export const GrammarlyProvider: FC<PropsWithChildren<unknown>> = (props) => {
  const [rightSidebarWidth, setRightSidebarWidth] = useState<number | undefined>(defaultRightSideWidth);
  const [composerHeight, setComposerHeight] = useState<number | undefined>();
  const [scrollbarWidth, setScrollbarWidth] = useState<number | undefined>();
  const [shouldGrammarlySuggestionOpen, setShouldGrammarlySuggestionOpen] = useState<boolean | undefined>();
  const contextValue = useMemo(
    () => ({
      rightSidebarWidth,
      composerHeight,
      scrollbarWidth,
      shouldGrammarlySuggestionOpen,
      setRightSidebarWidth,
      setComposerHeight,
      setScrollbarWidth,
      setShouldGrammarlySuggestionOpen,
    }),
    [composerHeight, rightSidebarWidth, scrollbarWidth, shouldGrammarlySuggestionOpen],
  );

  return <GrammarlyContext.Provider value={contextValue}>{props.children}</GrammarlyContext.Provider>;
};
